'use client';

import CategoryPage from '@/joystagram-components/components/consumer/CategoryPage';

export default function CategoryPageClient({
  serverCategoryData,
  useAlgolia,
  slug,
}) {
  return (
    <CategoryPage
      serverCategoryData={serverCategoryData}
      useAlgolia={useAlgolia}
      slug={slug}
    />
  );
}
